import React, { FC, useEffect, useState } from 'react';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import './ChatLoadingScreen.css';

const MESSAGES = [
  'Connecting you to your team\u2026',
  'We hope your performance times are faster than our loading!',
  'Warming up the chat engines\u2026',
  'Almost there \u2014 your teammates are waiting!',
  "Loading your conversations (we're blaming the internet, not us)",
];

const MESSAGE_INTERVAL_MS = 2800;
const FADE_DURATION_MS = 350;

interface Props {
  /** When true, the screen fills its parent via position: absolute. */
  overlay?: boolean;
}

const ChatLoadingScreen: FC<Props> = ({ overlay = false }) => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % MESSAGES.length);
        setVisible(true);
      }, FADE_DURATION_MS);
    }, MESSAGE_INTERVAL_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="chat-loading-screen" style={overlay ? { position: 'absolute', inset: 0, zIndex: 10 } : undefined}>
      {/* Spinning ring + icon */}
      <div className="chat-loading-icon-wrap">
        <div className="chat-loading-icon-ring" />
        <ChatBubbleOutlineIcon className="chat-loading-icon" />
      </div>

      {/* Bouncing dots */}
      <div className="chat-loading-dots">
        <span />
        <span />
        <span />
      </div>

      {/* Rotating witty message */}
      <div className="chat-loading-message-wrap">
        <p className={`chat-loading-message ${visible ? 'visible' : 'hidden'}`}>{MESSAGES[index]}</p>
      </div>

      {/* Animated progress bar */}
      <div className="chat-loading-bar-track">
        <div className="chat-loading-bar-fill" />
      </div>
    </div>
  );
};

export default ChatLoadingScreen;
